import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import BestMoversNearbyWrapper from "@components/layouts/bestMoversNearbyWrapper";

import { getPageProps } from "@services/initial-calls";
import PrivacyPolicy from "@components/shared/legal/privacyPolicy";

export default function PrivacyPolicyPage(): ReactElement {
    return (
        <BestMoversNearbyWrapper>
            <PrivacyPolicy category="Moving" domain="BestMoversNearby.com" />
        </BestMoversNearbyWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Privacy Policy" });
};
